var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightcenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.5H29C29.4729 6.5 30 6.92504 30 7.63043V25.3696C30 26.075 29.4729 26.5 29 26.5H3C2.52708 26.5 2 26.075 2 25.3696V7.63043C2 6.92504 2.52708 6.5 3 6.5ZM0 7.63043C0 5.90154 1.34315 4.5 3 4.5H29C30.6569 4.5 32 5.90154 32 7.63043V25.3696C32 27.0985 30.6569 28.5 29 28.5H3C1.34315 28.5 0 27.0985 0 25.3696V7.63043ZM15 14.5C14.4477 14.5 14 14.9477 14 15.5V17.5C14 18.0523 14.4477 18.5 15 18.5H27C27.5523 18.5 28 18.0523 28 17.5V15.5C28 14.9477 27.5523 14.5 27 14.5H15Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightcenter);
export default __webpack_public_path__ + "static/media/rightcenter.4b0c48b9.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightcenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.5H29C29.4729 6.5 30 6.92504 30 7.63043V25.3696C30 26.075 29.4729 26.5 29 26.5H3C2.52708 26.5 2 26.075 2 25.3696V7.63043C2 6.92504 2.52708 6.5 3 6.5ZM0 7.63043C0 5.90154 1.34315 4.5 3 4.5H29C30.6569 4.5 32 5.90154 32 7.63043V25.3696C32 27.0985 30.6569 28.5 29 28.5H3C1.34315 28.5 0 27.0985 0 25.3696V7.63043ZM15 14.5C14.4477 14.5 14 14.9477 14 15.5V17.5C14 18.0523 14.4477 18.5 15 18.5H27C27.5523 18.5 28 18.0523 28 17.5V15.5C28 14.9477 27.5523 14.5 27 14.5H15Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightcenter);
export default __webpack_public_path__ + "static/media/rightcenter.4b0c48b9.svg";
export { ForwardRef as ReactComponent };